import { StandardEvents } from '@shopify/events';
const latest = new WeakMap();
document.addEventListener(StandardEvents.productSelect, event => {
  if (!(event.target instanceof Element) || event.target.closest('product-card, [data-modello-color-card]')) return;
  const section = event.target.closest('.shopify-section');
  if (!section || !event.promise) return;
  const token = {};
  latest.set(section, token);
  event.promise.then(({ detail }) => {
    if (!section.isConnected || latest.get(section) !== token || !detail?.html) return;
    // The app still needs its amount attribute updated with Horizon's current event.
    section.querySelectorAll('square-placement, afterpay-placement').forEach(placement => {
      const amount = detail.html.getElementById(placement.id)?.getAttribute('data-amount');
      if (amount !== null && amount !== undefined) placement.setAttribute('data-amount', amount);
    });
    section.querySelectorAll('[data-modello-pdp-field]').forEach(field => {
      const replacement = detail.html.querySelector(`[data-modello-pdp-field="${field.dataset.modelloPdpField}"]`);
      if (!replacement) return;
      field.hidden = replacement.hidden;
      field.replaceChildren(...Array.from(replacement.childNodes, node => node.cloneNode(true)));
    });
  }).catch(() => { /* Native variant picker owns request errors and recovery. */ });
});
